import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import type React from "react";
export function AppLogo(t0) {
  const $ = _c(16);
  const {
    Icon,
    name,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const dim = size === "lg" ? "h-14 w-14" : size === "sm" ? "h-9 w-9" : "h-12 w-12";
  const iconDim = size === "lg" ? "h-8 w-8" : size === "sm" ? "h-5 w-5" : "h-7 w-7";
  if (Icon) {
    let t2;
    if ($[0] !== dim) {
      t2 = cn("flex shrink-0 items-center justify-center rounded-xl border border-border/40 bg-muted text-foreground", dim);
      $[0] = dim;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== Icon || $[3] !== iconDim) {
      t3 = <Icon className={iconDim} aria-hidden={true} focusable={false} />;
      $[2] = Icon;
      $[3] = iconDim;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
      t4 = <div className={t2} aria-hidden={true}>{t3}</div>;
      $[5] = t2;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  let t2;
  if ($[8] !== name) {
    t2 = name.replace(/^https?:\/\//, "").charAt(0).toUpperCase();
    $[8] = name;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const initial = t2;
  const t3 = size === "lg" ? "text-xl" : "text-base";
  let t4;
  if ($[10] !== dim || $[11] !== t3) {
    t4 = cn("flex shrink-0 items-center justify-center rounded-xl border border-border/40 bg-muted font-display font-semibold text-muted-foreground", dim, t3);
    $[10] = dim;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = initial || "?";
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t4} aria-hidden={true}>{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}